import React, { FC } from "react";

import { CloseButton } from "../../CloseButton/CloseButton";
import { useHandleClickAway } from "../../Hooks/useHandleClickAway";
import ClickAwayListener from "react-click-away-listener";
import classNames from "classnames";

type WaitWhileSmsModalProps = {
  onClose: () => void;
  isOpen: boolean;
  Modal: any;
  title: string;
  description: string;
  buttonText: string;
};

export const WaitWhileSmsModal: FC<WaitWhileSmsModalProps> = ({
  onClose,
  isOpen,
  Modal,
  title,
  description,
  buttonText,
}) => {
  const {
    handleMouseUp,
    handleMouseDown,
    handleClickAway,
    areaRef,
  } = useHandleClickAway(onClose);

  return (
    <Modal
      overlayClassName="react-modal__overlay"
      className={classNames("react-modal__content react-modal__content--additional", { 'react-modal__content--opened': isOpen })}
      isOpen={isOpen}
      shouldCloseOnEsc
      onRequestClose={onClose}
    >
      <div className="confirm-modal__outer">
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className="confirm-modal__inner my-2 p-2 pt-1 fs-5" ref={areaRef} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
            <CloseButton onClick={onClose} withWhiteBg />
            <h4>{title}</h4>
            <div dangerouslySetInnerHTML={{__html: description}}/>
            <div className="d-flex justify-content-center mt-2">
              <button className="btn btn-primary" onClick={onClose}>
                {buttonText}
              </button>
            </div>
          </div>
        </ClickAwayListener>
      </div>
    </Modal>
  );
};
